import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f223323c")

_pushScopeId("data-v-f223323c")
const _hoisted_1 = { class: "situation" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Radio = _resolveComponent("Radio")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Step = _resolveComponent("Step")

  return (_openBlock(), _createBlock(_component_Step, {
    step: _ctx.step,
    title: "Wat is uw situatie?"
  }, {
    footer: _withId(() => [
      _createVNode(_component_Navigation, {
        "allow-next": _ctx.state.situation !== null
      }, null, 8, ["allow-next"])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Radio, {
          modelValue: _ctx.state.situation,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.state.situation = $event)),
          value: _ctx.HealthState.Healthy,
          label: "Ik ben gezond",
          name: "situation"
        }, null, 8, ["modelValue", "value"]),
        _createVNode(_component_Radio, {
          modelValue: _ctx.state.situation,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.state.situation = $event)),
          value: _ctx.HealthState.ShortSick,
          label: "Ik ben korter dan twee jaar ziek of arbeidsongeschikt",
          name: "situation"
        }, null, 8, ["modelValue", "value"]),
        _createVNode(_component_Radio, {
          modelValue: _ctx.state.situation,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.state.situation = $event)),
          value: _ctx.HealthState.LongSick,
          label: "Ik ben twee jaar langer ziek of arbeidsongeschikt",
          name: "situation"
        }, null, 8, ["modelValue", "value"])
      ])
    ]),
    _: 1
  }, 8, ["step"]))
})